"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.096 4.7a1.7 1.7 0 0 1 1.7-1.7H11.5a.7.7 0 0 1 .501.211l3.705 3.8a.7.7 0 0 1 .198.489v7.8a1.7 1.7 0 0 1-1.7 1.7H5.796a1.7 1.7 0 0 1-1.7-1.7v-.8a.7.7 0 1 1 1.4 0v.8a.3.3 0 0 0 .3.3h8.408a.3.3 0 0 0 .3-.3V8.2H12.5a1.7 1.7 0 0 1-1.7-1.7V4.4H5.796a.3.3 0 0 0-.3.3v3.584a.7.7 0 1 1-1.4 0V4.7Zm8.104.72 1.344 1.38H12.5a.3.3 0 0 1-.3-.3V5.42Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m11.154 13-1.08-3.15h1.08l.563 2.138h.022l.563-2.138h1.08L12.302 13h-1.148Zm-2.343.09c-.855 0-1.327-.54-1.327-.54l.585-.607s.27.315.63.315c.225 0 .315-.09.315-.203 0-.36-1.418-.293-1.418-1.305 0-.518.473-.99 1.26-.99.81 0 1.17.45 1.17.45l-.585.607s-.157-.225-.472-.225c-.18 0-.27.068-.27.158 0 .36 1.417.293 1.417 1.305 0 .54-.495 1.035-1.305 1.035Zm-2.812 0c-1.035 0-1.778-.742-1.778-1.665S4.964 9.76 6 9.76c.922 0 1.372.607 1.372.607l-.607.653s-.27-.36-.743-.36c-.45 0-.787.338-.787.765s.337.765.787.765c.473 0 .765-.36.765-.36l.608.652s-.473.608-1.395.608Z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CsvFileIcon20.js.map